import { useReactiveVar } from '@apollo/client'
import React from 'react'
import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldError,
  RegisterOptions,
} from 'react-hook-form'
import { dictionariesVar } from '../../apollo/reactive-vars'
import { BuildingFragment, LocalGridFragment } from '../../generated/graphql'
import { providerProperties } from '../../provider/provider-properties'
import {
  MultiPicker,
  PickerCollection,
  PickerSubCollection,
} from './MultiPicker'

type Props = {
  containers: (BuildingFragment | LocalGridFragment)[]
  control: Control
  name: string
  defaultValue?: string[]
  rules?: RegisterOptions
  error?: FieldError
}

export function ControlledMultiProviderPicker(
  props: Props,
): React.ReactElement {
  const {
    control,
    name,
    defaultValue,
    rules,
    error,
    containers,
    ...inputProps
  } = props

  const { getSystemContainerTitle } = useReactiveVar(dictionariesVar)

  const collections: PickerCollection[] = containers.map(
    (container): PickerCollection => ({
      id: container.id,
      name: getSystemContainerTitle(container),
      subCollections: container.providers.map(
        (provider): PickerSubCollection => ({
          id: provider.id,
          name: provider.name,
          type: providerProperties[provider.type].providesEnergyTypes[0],
        }),
      ),
    }),
  )

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? []}
      rules={rules}
      render={({
        value,
        onChange,
      }: Omit<ControllerRenderProps, 'value'> & { value: string[] }) => (
        <MultiPicker
          {...inputProps}
          collections={collections}
          name={name}
          value={value}
          onChange={(newValue) => onChange(newValue)}
          error={error?.message}
        />
      )}
    />
  )
}
